import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import HomeIcon from "/public/images/icons/home.svg?react";
import ActivityIcon from "/public/images/icons/activity.svg?react";
import VenuesIcon from "/public/images/icons/venues.svg?react";
import SettingsIcon from "/public/images/icons/settings.svg?react";
import BookingsIcon from "/public/images/icons/bookings.svg?react";
import ScanIcon from "/public/images/icons/scan.svg?react";
import LogIcon from "/public/images/icons/log.svg?react";
import { useThemeContext } from "../../context/themeContext";
import { useUserContext } from "../../context/userContext";
import { useLiteDrawer } from "../../hooks/useLiteDrawer";

export default function MobileNav() {
  // Get the current router location
  const location = useLocation();
  const [navItems, setNavItems] = useState([]);
  // State to keep track of the active item
  const [activeItem, setActiveItem] = useState("");
  const { theme } = useThemeContext();
  const { user, selectedVenue } = useUserContext();
  const { showLiteDrawer } = useLiteDrawer();

  // Set the active item based on the current path
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navItems.find((item) => item.path === currentPath);
    if (matchingNavItem) {
      setActiveItem(matchingNavItem.id);
    }
  }, [location]);

  useEffect(() => {
    const newNavItems = [
      { id: "home", label: "Home", icon: HomeIcon, path: "/" },
      ...(theme !== "staff" || selectedVenue?.BookingSubscriptionId !== 0 ? [{
        id: "bookings",
        label: "Bookings",
        icon: BookingsIcon,
        path: "/bookings",
      }] : []),
      {
        id: "settings",
        label: "Settings",
        icon: SettingsIcon,
        path: "/settings",
      },
    ];

    if (theme === "staff") {
      newNavItems.splice(1, 0, {
        id: "scan",
        label: "Scan",
        icon: ScanIcon,
        path: "/scan?type=normal",
      });
      newNavItems.splice(2, 0, {
        id: "log",
        label: "Log",
        icon: LogIcon,
        path: "/staff-log",
      });
    } else {
      newNavItems.splice(1, 0, {
        id: "activities",
        label: "Activity",
        icon: ActivityIcon,
        path: "/log",
      });
      newNavItems.splice(2, 0, {
        id: "venues",
        label: "Venues",
        icon: VenuesIcon,
        path: "/venues",
      });
    }

    setNavItems(newNavItems);
  }, [theme, selectedVenue]);

  // Function to handle the click event on a navigation item
  const handleItemClick = (itemId) => {
    setActiveItem(itemId);
  };

  const handleNavClick = (e, item) => {
    if (item.id === "activities" && user?.subscription?.Name === "Lite") {
      e.preventDefault();
      showLiteDrawer();
    } else {
      handleItemClick(item.id);
    }
  };

  return (
    <div className="w-full h-[75px] max-w-[430px] fixed bottom-0 z-20">
      <ul className="w-full flex justify-between py-3 px-8 absolute bottom-0 border-t-sportsGrey/25 border-t-[1px] bg-white">
        {/* map over the navItems */}
        {navItems.map((item) => (
          <li
            key={item.id}
            className={`${
              activeItem === item.id
                ? "fill-black text-black"
                : "text-sportsGrey"
            }`}
          >
            <Link
              to={item.path}
              className="flex flex-col items-center capitalize text-[10px]"
              onClick={(e) => handleNavClick(e, item)}
            >
              {item.id === "home" || item.id === "scan" ? (
                <item.icon
                  className={`${
                    activeItem === item.id
                      ? "fill-black"
                      : "fill-sportsGrey hover:fill-black"
                  }`}
                />
              ) : (
                <item.icon
                  className={`${
                    activeItem === item.id
                      ? "stroke-black"
                      : item.id === "activities" && activeItem === "milestones"
                      ? "stroke-black"
                      : "stroke-sportsGrey hover:stroke-black"
                  }`}
                />
              )}
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
